<template>
  <div class='fill-over'>
      <div class='img-wrap'>
        <img  src="../../assets/image/success.png" alt="">
      </div>
      <h4>提交成功</h4>
      <p>请前往前台确认信息</p>
      <van-button class='default-btn'  block type="info" color='#E39E54'  @click="fillOver">我知道啦</van-button>
  </div>
</template>
<script>
  export default {
    name:'fillOver',
    data() {
      return {
      }
    },
    methods: {
      fillOver() {
        localStorage.removeItem('loginInfo')
        this.$router.replace('/checkLogin')
      }
    }
    
    
  }
</script>
<style lang="less" scoped>
.fill-over{
  width: 100%;
  max-width: 750px;
  height: 100vh;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  .img-wrap{
    width: 100%;
    img{
      width: 80px;
    }
  }
  
  h4{
    
  font-size: 17px;
  font-weight: 500;
  color: #03081A;
  line-height: 16px;
    margin: 16px 0 12px 0;
  }
}
p{
  font-size: 14px;
  font-weight: 400;
  color: #878B99;
  line-height: 14px;
  margin:0 0 50px 0;
}
.default-btn{
  width: calc(100% - 32px);
  margin: 0 auto;
  font-size: 17px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 17px;
  border-radius: 5px;
}
</style>